export function createDepartamento() {
  return {
    Clave: '',
    EmpresaId: 0,
    NombreDepartamento: '',
    Ceco1: '',
    Ceco2: '',
    Ceco3: '',
    Ceco4: '',
    Ceco5: '',
    DepartamentoIdPadre: 0,
    EmpleadoIdResponsable: 0,
    Nivel: 0,
    Descripcion: '',
    EsActivo: true
  };
}
